import React, { Component } from 'react'
import {ResourceUtil} from '../../uploadModal/file.type'
import {Icon} from 'antd'

// components
import ClazzVideo from './components/clazzVideo'
import ClazzAudio from './components/clazzAudio'
import ClazzDocument from './components/clazzDocument'
import ClazzPictures from './components/clazzPictures'
import ClazzLink from './components/clazzLink'
import ClazzZip from './components/clazzZip'
import ClazzClassIn from './components/clazzClassIn'

import LoadingResource from './components/loadingResource'

// model
import ClazzDetails from '../../../components/leco/models/clazzDetails'
import MediaExtradata from '../../eventTracking/model/mediaExtradata'
// model
import ChapterClazzItem from '../models/chapterClazzItem'
// style
import './style.less'

interface iProps {
    children?: React.ReactNode,
    clazzDetails: ClazzDetails,
    goBack: () => void,
    liveLink?: string,
    liveExtraData?: string,
    liveType?: string,
    reportData?: (params: MediaExtradata) => void,
    client?: string,
    showHandMark?: boolean
    currentClazz?: ChapterClazzItem,
    studyClazz?: (currentClazz) => void
}
interface iState {
    visible: boolean,
    toggle: boolean
}

export default class ClazzView extends Component<iProps, iState> {
    state: iState = {
        visible: true,
        toggle: true
    }
    // 数据上报
    eventTrackingReport = (parmas: MediaExtradata) => {
        this.props.reportData(parmas)
    }
    getComponent = (clazzDetails: ClazzDetails) => {
        if (clazzDetails.classTaskType === 'VIDEO') {
            return <ClazzVideo key={clazzDetails.id}
                    eventTrackingReport={this.eventTrackingReport} 
                    extraProps={clazzDetails.resourceDtos}
                    clazzId={clazzDetails.id}
                    resourceType={clazzDetails.resourceType}
                    spaceId={clazzDetails.containerId}
                    >
                </ClazzVideo>
        } else if (clazzDetails.classTaskType === 'AUDIO') {
            return <ClazzAudio key={clazzDetails.id}  
                    eventTrackingReport={this.eventTrackingReport} 
                    extraProps={clazzDetails.resourceDtos}
                    clazzId={clazzDetails.id}
                    spaceId={clazzDetails.containerId}></ClazzAudio>
        }  else if (clazzDetails.classTaskType === 'PICTURE') {
            return <ClazzPictures key={clazzDetails.id}  extraProps={clazzDetails.resourceDtos}></ClazzPictures>
        }  else if (clazzDetails.classTaskType === 'DOCUMENT') {
            return <ClazzDocument key={clazzDetails.id}  extraProps={clazzDetails.resourceDtos}></ClazzDocument>
        }  else if (clazzDetails.classTaskType === 'LINK') {
            return <ClazzLink key={clazzDetails.id}  extraProps={clazzDetails.resourceDtos}></ClazzLink>
        }  else if (clazzDetails.classTaskType === 'ZIP') {
            return <ClazzZip key={clazzDetails.id}  extraProps={clazzDetails.resourceDtos}></ClazzZip>
        }  else if (clazzDetails.classTaskType === 'LIVE') {
            return <ClazzClassIn 
                    key={clazzDetails.id} 
                    extraProps={{
                        recordResource: clazzDetails.recordResource || [],
                        title: clazzDetails.title,
                        playUrl: clazzDetails.playUrl,
                        startTime: clazzDetails.startTime, 
                        endTime: clazzDetails.endTime, 
                        classStatus: clazzDetails.classStatus,
                        livePhone:clazzDetails.livePhone,
                        roomLiveExtraDataDtos: clazzDetails.roomLiveExtraDataDtos,
                        liveType: this.props.liveType,
                        liveLink: this.props.liveLink,
                        liveExtraData: this.props.liveExtraData,
                        client: this.props.client,
                        clazzId: clazzDetails.id }}>
                    </ClazzClassIn>
        } else {
            return <LoadingResource></LoadingResource>
        }
    }
    // 切换
    toggleExtra = () => {
        this.setState({toggle: !this.state.toggle})
    }
    // 学习课时
    studyClazz = (currentClazz) => {
        if (currentClazz?.studyState !== 'DONE') {
            this.props.studyClazz(currentClazz)
        }
        return false
    }
    render() {
        let {children = null, clazzDetails, showHandMark, currentClazz} = this.props
        let {visible, toggle} = this.state
        return (
            <div
                // placement="left"
                // closable={false}
                // visible={visible}
                // maskClosable={false}
                className="clazzView"
            >
                <div className="clazzView_header">
                    <div className="clazzView_title">
                        <span className="clazzView_back" onClick={this.props.goBack}>
                            <Icon type="left" />
                            返回
                        </span>
                        【{ResourceUtil.fileShowMap(clazzDetails.classTaskType)?.name}】
                        {clazzDetails.title}
                    </div>
                    <div className="clazzView_teachers">
                        授课教师：
                        {clazzDetails.teacherCommonUsers &&
                        !!(clazzDetails.teacherCommonUsers.length) && 
                        clazzDetails.teacherCommonUsers.map((item, index) => (index > 0 ? '、' +item.userName : item.userName))}
                    </div>
                </div>
                <div className="clazzView_content">
                    <div className="clazzView_content_play">
                        {
                            this.getComponent(clazzDetails)
                        }
                        <div className="clazzView_toggle_extra"  onClick={this.toggleExtra}>
                            {
                                toggle ? <Icon type="right" /> : <Icon type="left" />
                            }
                        </div>
                    </div>
                    {children && 
                    <div className="clazzView_content_extra" style={{display: toggle? 'block': 'none'}}>
                        {children}
                    </div>}
                </div>
                <div className="clazzView_bottom">
                    <div className='clazzView_bottom_des'>课时描述：{clazzDetails.description}</div>
                    {showHandMark && 
                        <div className='clazzView_bottom_state' onClick={this.studyClazz.bind(null, currentClazz)}>
                            {currentClazz?.studyState !== 'DONE' && <div className='clazzView_bottom_state_icon'></div>}
                            {currentClazz?.studyState !== 'DONE' ? '学过了' : '已完成'} 
                        </div>
                    }
                </div>
            </div>
        )
    }
}
